import { makeStyles } from '@material-ui/styles'

const styles = makeStyles({
  container: {
    marginLeft: 20,
  },
})

export default styles
